import { defineStore } from "pinia";

export const useConnectionStore = defineStore('connectionStore', {
  state : () => ({
    cookie : "",
    dummy : 1,
    isSubscriber : 0,
    subscriberExpireDate : 0,
    subscriberExpireDisplayString : "",
    lastStartupCheckDate : 0,
    lastNewInfoDate : 0,
    coordinateLocation : "in",
    verified : "",
    subscriptionIsFree : "",
    haveAlreadyDoneThisFreeSubscription : "",
    subscriptionCanUpgrade : "",

    // not on server
    emailAddress : null,
    darkmode : null,
    uuid : "",

    // type of puzzle, move following - anything that shares the same target routine
    puzzleOption : "solveit",
    moveOption : "begin",
    engineOption : "computer",
    lichessOption : "rapid",
    explorerOption : "winloss",
    productOption : "puzzles",

    canShowHideMenu : false,

    gameId : 0,

    lichessAccessToken : "",
    lichessUserid : "",
    lichessGameId : "",
    lichessFriendId : "",
    lichessFriendName : "",
    lichessVerifier : "",

    // eye gaze & menu
    isEyeGaze : false,
    hideMenu : null,
    chessvisVersion : "V8.3.6"

  }),
  getters: {
    getIsEyeGaze() {
      return this.isEyeGaze
    },
    getHideMenu() {
      return this.hideMenu
    },
    getLichessGameId() {
      //this.lichessGameId = localStorage.getItem("lichessGameId")
      return this.lichessGameId
    },
    getLichessAccessToken() {
      this.lichessAccessToken = localStorage.getItem("lichessAccessToken")
      return this.lichessAccessToken
    },
    getLichessUserid() {
      //this.lichessUserid = localStorage.getItem("lichessUserid")
      return this.lichessUserid
    },
    getPuzzleOption() {
      return this.puzzleOption
    },
    getMoveOption() {
      return this.moveOption
    },
    getEngineOption() {
      return this.engineOption
    },  
    getLichessOption() {
      return this.lichessOption
    },
    getExplorerOption() {
      return this.explorerOption
    },
    getPreferenceCanShowHideMenu() {
      return this.canShowHideMenu
    },
    getProductOption() {
      return this.productOption
    },
    getGameId() {
      this.gameId = localStorage.getItem("gameId")
      return this.gameId
    },
    getLichessFriend() {
      this.lichessFriendId = localStorage.getItem("lichessFriendId")
      this.lichessFriendName = localStorage.getItem("lichessFriendName")
      return { id : this.lichessFriendId , name : this.lichessFriendName }
    },
    getLichessVerifier() {
      this.lichessVerifier = localStorage.getItem("lichessVerifier")
      //console.log("in connectstore read verifier",this.lichessVerifier)
      return this.lichessVerifier
    },
    getUUID() {
      this.uuid = localStorage.getItem("uuid")
      return this.uuid
    },
    getStoredUserData() {
      //console.log("in connection store ",this.cookie,this.dummy,this.lastNewInfoDate)

      // if no cookie in memory, see if user's value has been saved in localStorage
      //    if in localStorage, then load cookie & dummy, set all the other fields to 0
      //       set the last startup check date to zero to get a call going to the server
      if (this.cookie === "") {
        this.cookie = localStorage.getItem("cookie")
        this.dummy = localStorage.getItem("dummy")        
        
        // if no saved cookie & dummy, then set them to ""
        if (this.cookie == null || this.dummy == null) {
          this.cookie = ""
          this.dummy = 1
        }

        this.isSubscriber = 0
        this.subscriberExpireDate = 0
        this.subscriberExpireDisplayString = ""

        this.lastStartupCheckDate = 0
        this.lastNewInfoDate = 0 
        this.coordinateLocation = "in"

        this.verified = "n"
        this.subscriptionType = ""
        this.haveAlreadyDoneThisFreeSubscription = "n"
        this.subscriptionCanUpgrade = ""
      }

      // These two fields aren't on the server. If not set, see if saved
      if (this.emailAddress == null) {
        this.emailAddress = localStorage.getItem("email")
        if (this.emailAddress == null)   
          this.emailAddress = ""
      }

      // see if darkmode already set, also fix any old values
      if (this.darkmode == null)
        this.darkmode = localStorage.getItem("dark")
      if (this.darkmode == null || this.darkmode == "n" || this.darkmode == "") {
        this.darkmode = "light"
      }
      else
        if (this.darkmode == "y")
          this.darkmode = "dark"

      if (this.uuid == null) {
        this.uuid = localStorage.getItem("uuid")
        if (this.uuid == null)   
          this.uuid = ""
      }

      if (this.hideMenu == null) {
        const hideMenuString = localStorage.getItem("hidemenu")
        this.hideMenu = (hideMenuString == "hide") ? true : false
      }

      //console.log("************    get stored user data -- before return",this.cookie,this.dummy,this.lastNewInfoDate)

      return { 
        cookie : this.cookie, 
        dummy : this.dummy, 
        isSubscriber : this.isSubscriber,
        subscriberExpireDate : this.subscriberExpireDate, 
        subscriberExpireDisplayString : this.subscriberExpireDisplayString,
        lastStartupCheckDate : this.lastStartupCheckDate,
        lastNewInfoDate : this.lastNewInfoDate,
        coordinateLocation : this.coordinateLocation,

        verified : this.verified,
        subscriptionIsFree : this.subscriptionIsFree,
        haveAlreadyDoneThisFreeSubscription : this.haveAlreadyDoneThisFreeSubscription,
        subscriptionCanUpgrade : this.subscriptionCanUpgrade,

        emailAddress : this.emailAddress,
        darkmode : this.darkmode,

        uuid : this.uuid,
        lichessAccessToken : this.lichessAccessToken,
        lichessUserid : this.lichessUserid,
        lichessVerifier : this.lichessVerifier,

        isEyeGaze : this.isEyeGaze,
        hideMenu : this.hideMenu,
        chessvisVersion : this.chessvisVersion
      }
    }
  },
  actions: {
    updateStoredUserCookieDummy(cookie,dummy) {
      this.cookie = cookie
      localStorage.setItem("cookie",cookie)
      this.dummy = dummy
      localStorage.setItem("dummy",dummy)

      // zero out all the other fields on a setting of cookie & dummy. will reload from server
      this.lastStartupCheckDate = 0
      this.lastNewInfoDate = 0
      this.coordinateLocation = "in"
      this.isSubscriber = 0
      this.subscriberExpireDate = 0
      this.subscriberExpireDisplayString = ""
      this.subscriptionCanUpgrade = ""

      this.verified = "n"
      this.subscriptionIsFree = ""
      this.haveAlreadyDoneThisFreeSubscription = "n"
    },

    updateUserDataFromServer(isSubscriber,subscriberExpireDate,subscriberExpireDisplayString,
              startupDate,newInfoDate, coordinate,
              verified,subscriptionIsFree,haveAlreadyDoneThisFreeSubscription,
              subscriptionCanUpgrade) {
      this.isSubscriber = isSubscriber
      this.subscriberExpireDate = subscriberExpireDate
      this.subscriberExpireDisplayString = subscriberExpireDisplayString
      this.lastStartupCheckDate = startupDate
      this.lastNewInfoDate = newInfoDate
      this.coordinateLocation = coordinate
      this.verified = verified
      this.subscriptionIsFree = subscriptionIsFree
      this.haveAlreadyDoneThisFreeSubscription = haveAlreadyDoneThisFreeSubscription
      this.subscriptionCanUpgrade = subscriptionCanUpgrade
    },
    updateCoordinateLocation(coordinate) {
      //console.log("**** update coordinate location",coordinate)
      this.coordinateLocation = coordinate
    },
    updateHideMenu(hideMenu) {
      this.hideMenu = hideMenu
      localStorage.setItem("hidemenu",(hideMenu) ? "hide" : "show")
    },
    updateEmailAddress(email) {
      this.emailAddress = email
      localStorage.setItem("email",email)
    },
    updateDarkmode(darkmode) {
      this.darkmode = darkmode
      localStorage.setItem("dark",darkmode)
    },
    setPuzzleOption(puzzleOption) {
      this.puzzleOption = puzzleOption
    },
    setMoveOption(moveOption) {
      this.moveOption = moveOption
    },
    setEngineOption(engineOption) {
      this.engineOption = engineOption
    },
    setExplorerOption(explorerOption) {
      this.explorerOption = explorerOption
    },
    setProductOption(productOption) {
      this.productOption = productOption
    },
    setPreferenceCanShowHideMenu(canShowHideMenu) {
      this.canShowHideMenu = canShowHideMenu
    },
    updateUUID(uuid) {
      this.uuid = uuid
      localStorage.setItem("uuid",uuid)
    },
    setLichessOption(lichessOption) {
      this.lichessOption = lichessOption
    },
    setGameId(gameId) {
      this.gameId = gameId
      localStorage.setItem("gameId",gameId)
    },
    setLichessAccessToken(token) {
      this.lichessAccessToken = token
      localStorage.setItem("lichessAccessToken",token)
    },
    setLichessUserid(userid) {
      this.lichessUserid = userid
      localStorage.setItem("lichessUserid",userid)
    },
    setLichessVerifier(verifier) {
      this.lichessVerifier = verifier
      //console.log("in connectstore set verifier",verifier)
      localStorage.setItem("lichessVerifier",verifier)
    },
    setLichessGameId(lichessGameId) {
      this.lichessGameId = lichessGameId
      localStorage.setItem("lichessGameId",lichessGameId)
    },
    setLichessFriend(friendId,friendName) {
      this.lichessFriendId = friendId
      this.lichessFriendName = friendName
      localStorage.setItem("lichessFriendId",friendId)
      localStorage.setItem("lichessFriendName",friendName)
    },
  }

})
